import * as React from "react";
import * as CH from "@chakra-ui/react";
import { cloneDeep } from "lodash-es";
import { Editor, Path, Transforms } from "slate";
import { ReactEditor, useSlate } from "slate-react";
import { EMPTY_NODE } from "../../duck";
import { isAddAllowed } from "./duck";

/*
  small clickable areas at the top and at the bottom of redactor
  help to handle cases when we want type before or after some elements
 */

const AddOnClickArea: React.FC<{
  children: React.ReactNode;
  readOnly: boolean;
}> = ({ children, readOnly }) => {
  const theme = CH.useTheme();
  const editor = useSlate();

  const firstElement = editor.children[0];
  const isAddBeforeAllowed = isAddAllowed(firstElement);

  const lastElement = editor.children[editor.children.length - 1];
  const isAddAfterAllowed = isAddAllowed(lastElement);

  const handleInsert = (path: Path) => {
    Transforms.insertNodes(editor, cloneDeep(EMPTY_NODE), {
      at: path
    });

    const start = Editor.start(editor, path);
    ReactEditor.focus(editor);
    Transforms.setSelection(editor, { anchor: start, focus: start });
  };

  return (
    <>
      {!readOnly && (
        <CH.Box
          cursor={isAddBeforeAllowed ? "text" : "default"}
          height={theme.sizes["2.5"]}
          onClick={e => {
            e.preventDefault();
            if (!isAddBeforeAllowed) return;
            handleInsert([0]);
          }}
        />
      )}

      {children}

      {!readOnly && (
        <CH.Box
          cursor={isAddAfterAllowed ? "text" : "default"}
          height={theme.sizes["2.5"]}
          onClick={e => {
            e.preventDefault();
            if (!isAddAfterAllowed) return;
            handleInsert([editor.children.length]);
          }}
        />
      )}
    </>
  );
};

export default AddOnClickArea;
